








































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { EnergyDisplay } from '../interfaces';
import Note from '@/components/Note.vue';

export interface INote {
    id: string;
    colour: string;
    text: string;
}

@Component({
    components: {
        Note,
    },
})
export default class Notes extends Vue {
    private noteTextValue: string = '';
    private notes: INote[] = [];

    public created() {
        return;
    }

    public mounted() {
        const self = this;

        this.notes = JSON.parse(
            localStorage.getItem('user_notifications') || '[]',
        );
        if (this.notes == null) {
            this.notes = [];
        }
    }

    private addNote() {
        const random_id: string = Math.random()
            .toString(36)
            .slice(2);
        const newNote: INote = {
            id: random_id,
            colour: 'yellow',
            text: this.noteTextValue,
        };
        this.notes.push(newNote);
        localStorage.setItem('user_notifications', JSON.stringify(this.notes));
    }

    private onNoteDeleted(uniqueId: string) {

        const filteredElements = this.notes.filter((note, index) => {
            return note.id !== uniqueId;
        });

        this.notes = filteredElements;

        localStorage.setItem(
            'user_notifications',
            JSON.stringify(this.notes),
        );
    }
}
